import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { addToCartEvent } from 'events/cart';

import { isDesktop } from 'helpers/ClientUtils';
import { cartError, cartIsLoading, changeQuantity } from 'actions/cart';
import { fetchHeartList } from 'actions/hearts';
import { translateCartError } from 'apis/mafia';
import CartItem from 'components/cart/CartItem';
import marketplace from 'cfg/marketplace.json';
import css from 'styles/components/cart/cartFavorites.scss';

const { cart: { cartName } } = marketplace;

const makeCTAVerbiage = ({ isInCart, favAdding }) => {
  // already in cart
  if (isInCart) {
    return `Added to ${cartName}`;
  }

  // in the process of adding to cart
  if (favAdding) {
    return 'Adding...';
  }

  // is not in cart
  return `Add to ${cartName}`;
};

export class CartFavorites extends Component {
  static contextTypes = {
    testId: PropTypes.func,
    marketplace: PropTypes.object
  };

  state = {
    adding: null
  }

  componentDidMount() {
    const {
      fetchHeartList,
      isCustomer,
      hearts
    } = this.props;

    const { marketplace: { checkout: { allowMoveToFavorites } } } = this.context;

    // hearts is enabled && is desktop && is a customer && hearts havent been fetched yet
    if (allowMoveToFavorites && isDesktop(marketplace) && isCustomer && !hearts.hearts) {
      fetchHeartList({ suppressAuthCatch: true });
    }
  }

  onAddToCart = ({ currentTarget }, win = window) => {
    const { changeQuantity, cartError, cartIsLoading, addToCartEvent } = this.props;
    const { asin } = currentTarget.dataset;

    this.setState({ adding: asin });
    cartIsLoading();

    changeQuantity({ items: [{ asin, quantity: 1 }] }).then(response => {
      const error = translateCartError(response);
      this.setState({ adding: null });
      if (error) {
        cartError(error);
        win.scrollTo(0, 0);
      } else {
        const product = response.activeItems?.filter(item => item.asin === asin);
        addToCartEvent(product[0]);
      }
    });
  }

  makeHearts = item => {
    const { testId } = this.context;
    const { adding } = this.state;
    const { cart: { activeItems, savedItems } } = this.props;

    const { asin, itemId } = item;

    const allCartItems = [ ...activeItems, ...savedItems ];

    const favAdding = asin === adding;
    const isInCart = !!allCartItems.some(item => item.asin === asin);

    return (
      <CartItem
        key={itemId}
        item={item}
        hasFullDetails={false}
        isFavorite={true}>
        <div className={css.action}>
          <button
            type="button"
            disabled={isInCart || favAdding}
            data-asin={asin}
            data-id={itemId}
            data-test-id={testId('addToCart')}
            onClick={this.onAddToCart}>{makeCTAVerbiage({ isInCart, favAdding })}</button>
        </div>
      </CartItem>
    );
  }

  render() {
    const { hearts: { hearts } } = this.props;

    if (!hearts?.length) {
      return null;
    }

    const filteredHearts = hearts.filter(({ quantity, asin }) => quantity && asin);

    if (!filteredHearts.length) {
      return null;
    }

    return (
      <div className={css.container}>
        <h2>Your Favorites</h2>
        <div className={css.heading}>
          <span>Item</span>
        </div>

        <div className={css.items}>
          {filteredHearts.map(this.makeHearts)}
        </div>
      </div>
    );
  }
}

export const mapStateToProps = state => {
  const {
    cart: { cartObj: cart },
    cookies,
    hearts
  } = state;

  const isCustomer = !!cookies['x-main'];

  return {
    cart,
    hearts,
    isCustomer
  };
};

export default connect(mapStateToProps, {
  cartError,
  cartIsLoading,
  changeQuantity,
  fetchHeartList,
  addToCartEvent
})(CartFavorites);
